import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import {
  BuyerImport,
  ImportBuyerContext,
  ImportRequest,
  ImportResponse,
} from '@tinct/core-api-models';
import { ApiError, tinctApi } from '../../api';

export type ImportBuyersParams = ImportRequest<BuyerImport, ImportBuyerContext>;

export const importBuyers = async (
  params: ImportBuyersParams
): Promise<ImportResponse> => {
  return await tinctApi.buyers.importBuyers(params);
};

export const useImportBuyers = (
  options?: Omit<
    UseMutationOptions<ImportResponse, ApiError, ImportBuyersParams>,
    'mutationFn'
  >
) => {
  const { onSuccess, ...restOptions } = options || {};
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: importBuyers,
    onSuccess: (...args) => {
      // Invalidate buyers queries after a successful import
      queryClient.invalidateQueries({ queryKey: ['buyers'] });
      onSuccess?.(...args);
    },
    ...restOptions,
  });
};
